import { GoogleAddressComponentTypes, InternationalAddressCountryTypes } from "@iddataweb/idw-common-ui/enums";
import { GoogleAddressComponentDisplay } from "@iddataweb/idw-common-ui/types";
import * as Yup from "yup";

export const getManualComponents = (addressComponents: { [key: string]: string }) => {
	return Object.values(GoogleAddressComponentTypes).reduce((addressComponentsObj, addressComponentName) => {
		const relatedComponent = addressComponents[addressComponentName];
		//@ts-ignore
		addressComponentsObj[addressComponentName] = relatedComponent ? relatedComponent : "";
		return addressComponentsObj;
	}, {} as { [key in GoogleAddressComponentTypes]: string });
};

export const getAddressComponents = (addressComponents: google.maps.GeocoderAddressComponent[]) => {
	return Object.values(GoogleAddressComponentTypes).reduce((addressComponentObj, addressComponentName) => {
		const relatedComponent = addressComponents.find((comp) =>
			comp.types.includes(addressComponentName)
		);
		//@ts-ignore
		addressComponentObj[addressComponentName] = relatedComponent
			? relatedComponent.short_name || relatedComponent.long_name
			: '';
		return addressComponentObj;
	}, {} as { [key in GoogleAddressComponentTypes]: string });
};

export const getFormattedAddress = (
	componentValues: { [key: string]: string },
	addressComponents: Array<GoogleAddressComponentDisplay>
) => {
	let finalAddress = '';

	addressComponents.forEach((component, index) => {
		if (componentValues[component.name]) {
			finalAddress += componentValues[component.name];
			if (index !== addressComponents.length - 1) {
				if (component.hasComma) {
					finalAddress += ", ";
				} else {
					finalAddress += " ";
				}
			}
		}
	});

	return finalAddress;
};

export const getYupSchemaForGoogleAddressComponents = (components: Array<GoogleAddressComponentDisplay>) => {

	const schema: { [key: string]: Yup.StringSchema<string, object, string, any, string> } = {};
	components.forEach(component => {
		if (![GoogleAddressComponentTypes.SUBPREMISE].includes(component.name)) {
			schema[component.name] = Yup.string()
				.required(`validation.internationaladdress.${component.name}.required`)
				.matches(/^\S.*\S$/, `validation.internationaladdress.${component.name}.required`);
		}
	});

	return schema;
};

export const initializeComponentsFields = (countryCode: InternationalAddressCountryTypes) => {
	return Object.values(GoogleAddressComponentTypes).reduce((addressComponentObj, addressComponentName) => {
		if (addressComponentName === GoogleAddressComponentTypes.COUNTRY) {
			addressComponentObj[GoogleAddressComponentTypes.COUNTRY] = countryCode;
		} else {
			//@ts-ignore
			addressComponentObj[addressComponentName] = '';
		}
		return addressComponentObj;
	}, { country: undefined });
};

export const getInitialLocation = (countryCode: InternationalAddressCountryTypes) => {
	return {
		address: '',
		components: initializeComponentsFields(countryCode)
	};
};
